import React, { FC, useCallback, useRef } from 'react';
import { castDate, formatDate } from '@factorin/util';
import { container } from '@factorin/container';

import { useTranslation } from 'Modules/core/i18n';
import { Omit, CalendarInputProps, CalendarInput, cn, Button, CalendarInputMethods } from 'Modules/ui';

import { withFormField } from '../FormField';
import styles from './index.module.scss';


export type TranslatedCalendarInputProps = Omit<CalendarInputProps, 'locale'>;

const buttonCaptions = {
    en: {
        reset: 'Reset',
        today: 'Today is',
    },
    ru: {
        reset: 'Очистить',
        today: 'Сегодня',
    },
};

export const TranslatedCalendarInput: FC<TranslatedCalendarInputProps> = ({
    className,
    value,
    onChange,
    children,
    name,
    ...props
}) => {
    const { i18n } = useTranslation();
    const calendarInput = useRef<CalendarInputMethods>();
    const reset = useCallback(
        () => {
            onChange(null);
            calendarInput.current.close();
        },
        [onChange],
    );
    const today = useCallback(
        () => {
            onChange(new Date());
            calendarInput.current.close();
        },
        [onChange],
    );
    return (
        <CalendarInput
            data-testid={`input-${name}`}
            ref={calendarInput}
            className={cn(styles.calendar, className)}
            locale={i18n.language as 'en' | 'ru'}
            value={castDate(value)}
            onChange={onChange}
            name={name}
            {...props}
        >
            <Button data-testid='calendar-today' variant='auxiliary' className={styles.button} onClick={today}>
                {buttonCaptions[container.i18n.language].today} {formatDate(new Date())}
            </Button>
            <Button data-testid='calendar-reset' variant='auxiliary' className={styles.button} onClick={reset}>
                {buttonCaptions[container.i18n.language].reset}
            </Button>
        </CalendarInput>
    );
};

export const CalendarField = withFormField<TranslatedCalendarInputProps>(TranslatedCalendarInput);
